import { render } from "./SlideshowSlideshow.vue?vue&type=template&id=2fd45e8a&scoped=true&lang=html"
import script from "./SlideshowSlideshow.vue?vue&type=script&lang=js"
export * from "./SlideshowSlideshow.vue?vue&type=script&lang=js"

import "./SlideshowSlideshow.vue?vue&type=style&index=0&id=2fd45e8a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd45e8a"]])

export default __exports__